/*
  Show more / Show less for long filter groups (snippets/facets.liquid).

  facets.liquid loads this file and renders <show-more-button> under every
  list filter with more than 10 values. Values 11+ carry the classes
  "show-more-item hidden". Clicking the button toggles those items and swaps
  the "+ Show more" / "- Show less" labels. Nothing else is touched: the
  checkboxes, counts and filtering logic stay in facets.js.

  Exception: the compact Color filter (product metafield custom.color_family,
  max 11 colour families) is always shown in full, without a button.

  Works for every filter group generically, and keeps working after
  facets.js re-renders the filter HTML (custom elements upgrade on insert).
*/
if (!customElements.get('show-more-button')) {
  class ShowMoreButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        this.toggleItems(button);
      });
    }

    connectedCallback() {
      const button = this.querySelector('button');
      if (button && !button.hasAttribute('aria-expanded')) {
        button.setAttribute('aria-expanded', 'false');
      }

      const parentDisplay = this.closest('.parent-display');
      if (parentDisplay && parentDisplay.querySelector('input[name="filter.p.m.custom.color_family"]')) {
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.remove('hidden'));
        this.hidden = true;
        this.style.display = 'none';
      }
    }

    toggleItems(button) {
      const parentDisplay = this.closest('.parent-display');
      if (!parentDisplay) return;

      const items = parentDisplay.querySelectorAll('.show-more-item');
      if (!items.length) return;

      const expand = items[0].classList.contains('hidden');
      items.forEach((item) => item.classList.toggle('hidden', !expand));

      const showMore = this.querySelector('.label-show-more');
      const showLess = this.querySelector('.label-show-less');
      if (showMore) showMore.classList.toggle('hidden', expand);
      if (showLess) showLess.classList.toggle('hidden', !expand);
      button.setAttribute('aria-expanded', expand ? 'true' : 'false');

      if (expand) {
        const firstInput = items[0].querySelector('input:not([disabled])');
        if (firstInput) firstInput.focus({ preventScroll: true });
      }
    }
  }

  customElements.define('show-more-button', ShowMoreButton);
}
